import {Component, OnInit} from '@angular/core';
import {CpProvisionTypeBaseComponent} from '../base/cp-provision-type-base.component';

/**
 * Full view of the ProvisionType object component (`uiMode = 'full'`, layer 2 of PAT §L.2).
 *
 * In-module precedent: `../../../cp-provision-agent-object/view/full/`; its own reference is
 * `bm-billing-area-full.component.ts`. The component inherits the `navigationItems` and the child
 * descriptors from {@link CpProvisionTypeBaseComponent} and renders exactly ONE shared component
 * per active navigation point. It holds no business logic and no form HTML of its own.
 */
@Component({
    selector: 'cp-provision-type-full',
    templateUrl: './cp-provision-type-full.component.html',
    styleUrls: ['./cp-provision-type-full.component.scss'],
    standalone: false
})
export class CpProvisionTypeFullComponent extends CpProvisionTypeBaseComponent implements OnInit {

    ngOnInit() {
        super.ngOnInit();
    }

}
